var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "26px",
    viewBox: "0 0 20 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A6BF4E5A-3E9C-4B09-BB53-42B7D99EBD48") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,12.7157086 C7.0958209,12.7157086 4.74141791,9.86922857 4.74141791,6.35789143 C4.74141791,2.84648 5.51455224,0 10,0 C14.4854478,0 15.2584328,2.84648 15.2584328,6.35789143 C15.2584328,9.86922857 12.9040299,12.7157086 10,12.7157086 Z M19.9205224,22.1666343 C19.9267164,22.5578971 19.93,22.6255714 19.9316418,22.5906571 C19.9314179,22.69436 19.9312687,22.8467943 19.9312687,23.0660114 C19.9312687,23.0660114 18.4690299,26 9.99992537,26 C1.53067164,26 0.0685820896,23.0660114 0.0685820896,23.0660114 C0.0685820896,22.7248171 0.0681343284,22.5291486 0.067761194,22.4233657 C0.0694029851,22.4798229 0.0736567164,22.4542686 0.0828358209,21.96792 C0.194776119,16.0119143 1.0461194,14.2948 7.12037313,13.2035429 C7.12037313,13.2035429 7.985,14.3000743 9.99992537,14.3000743 C12.0148507,14.3000743 12.8793284,13.2035429 12.8793284,13.2035429 C19.020597,14.3068343 19.8231343,16.0498 19.9205224,22.1666343 Z",
    id: "path-user-regular"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16E55",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C00000",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "High-Fi-Dashboard-T2P",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picking---T2P",
    transform: "translate(-87.000000, -1080.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.000000, 142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tiempos-de-Picking-[Div]",
    transform: "translate(0.000000, 853.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Primer-Lugar-[Col-4]",
    transform: "translate(0.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Primer-Lugar",
    transform: "translate(30.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FirstPlace-Icon",
    transform: "translate(1.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-user-regular",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-user-regular"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#000000",
    xlinkHref: "#path-user-regular"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8Color",
    mask: "url(#mask-user-regular)",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Gradient",
    x: 0,
    y: 0,
    width: 20,
    height: 26
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRegular);
export default __webpack_public_path__ + "static/media/user-regular.dde7c3cb73c9f83416fc69947446a78f.svg";
export { ForwardRef as ReactComponent };